import { useMemo } from "react";

import Grid from "@mui/material/Grid";

import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

import { ExtraQuestion } from "./ExtraQuestion";

export function ExtraQuestions() {
  const {
    noEmail,
    hasAutoPolicy,
    physicallyMailDocuments,
    hasAnotherCoverTreePolicy,
  } = useNewBusinessSelector(selectBasicQuestions);

  const filteredQuestions = useMemo(
    () =>
      [
        noEmail,
        physicallyMailDocuments,
        hasAutoPolicy,
        hasAnotherCoverTreePolicy,
      ].filter((question) => !!question),
    [noEmail, hasAutoPolicy, physicallyMailDocuments, hasAnotherCoverTreePolicy]
  );

  return (
    <Grid item container spacing={4}>
      {filteredQuestions.map((question) => (
        <Grid key={question.fieldName} item xs={12}>
          <ExtraQuestion question={question} />
        </Grid>
      ))}
    </Grid>
  );
}
